import { create } from 'zustand';

export type ModalState<TData> = {
  isOpen: boolean;
  modalId: string;
  data: TData | null;
  toggleModal: (modalId?: string, data?: TData) => void;
};

export type ModalsState<TData> = {
  modals: {
    [key: string]: {
      isOpen: boolean;
      data?: TData;
    };
  };
  toggleModal: (modalId: string, data?: TData) => void;
  getModalData: (modalId: string) => TData;
  setModalData: (modalId: string, data: TData) => void;
  isModalOpen: (modalId: string) => boolean;
};

export const modalsStore = <TData>() =>
  create<ModalsState<TData>>((set, get) => ({
    modals: {},
    toggleModal: (modalId: string, data?: TData) => {
      set(state => {
        const currentModal = state.modals[modalId];
        const isCurrentlyOpen = currentModal?.isOpen || false;

        if (isCurrentlyOpen) {
          // If closing, remove the modal data completely
          const { [modalId]: _, ...restModals } = state.modals;
          return { modals: restModals };
        } else {
          // If opening, set new data
          return {
            modals: {
              ...state.modals,
              [modalId]: {
                isOpen: true,
                data: data,
              },
            },
          };
        }
      });
    },
    getModalData: (modalId: string): TData => {
      return get().modals[modalId]?.data as TData;
    },
    setModalData: (modalId: string, data?: TData) => {
      set(state => {
        return {
          modals: {
            ...state.modals,
            [modalId]: {
              ...state.modals[modalId],
              data: data,
            },
          },
        };
      });
    },
    isModalOpen: (modalId: string): boolean => {
      return get().modals[modalId]?.isOpen || false;
    },
  }));
